var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGreenTick(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_740_22)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.68507 0.975586C3.09445 0.975586 0.986816 3.08322 0.986816 5.67384C0.986816 8.26446 3.09445 10.3721 5.68507 10.3721C8.27569 10.3721 10.3833 8.26446 10.3833 5.67384C10.3833 3.08322 8.27569 0.975586 5.68507 0.975586ZM4.74589 7.74718L3.33381 6.33814C3.15022 6.15495 3.14985 5.85764 3.33298 5.67399V5.67399C3.51622 5.49023 3.81376 5.48989 3.99743 5.67323L4.74495 6.41946L6.90004 4.26437C7.08349 4.08092 7.38093 4.08091 7.56438 4.26437V4.26437C7.74783 4.44782 7.74783 4.74525 7.56438 4.9287L4.74589 7.74718Z",
    fill: "#2FAB73"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_740_22"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.2758,
    height: 11.2758,
    fill: "white",
    transform: "translate(0.0467529 0.0360107)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenTick);
export default __webpack_public_path__ + "static/media/Green-tick.0294778832d2afbd3d43fe720fc55bb1.svg";
export { ForwardRef as ReactComponent };